import { FC } from 'react';
import { CardContent as MuiCardContent, CardContentProps } from '@mui/material';

export const CardContent: FC<CardContentProps> = ({ children, sx, ...props }) => (
  <MuiCardContent {...props} sx={{ paddingInline: 4, paddingBlock: 1, maxWidth: '75ch', ...sx }}>
    {children}
  </MuiCardContent>
);
